var app = new Vue({
    el: '#app',
    data: {
        
    },
    created: function () {

    },
    mounted: function () { 
       

    },
    watch: {

    },
    methods: {
        openDetail:function(type){ 
            var me = this;
            var data = {};
            data.method="open_page"; 
            data.name = "privacy_self_info_detail";
            data.arguments = {}
            data.arguments.type = type;
            me._sendMessageToTCR(data);
        },
        _sendMessageToTCR : function (params){
                    if (window.TCR == undefined){
                        console.log("TCR is undefined");
                        return;
                    }
                    var res = TCR.postMessage(JSON.stringify(params));
             },
        _sendMessageToTCRTool : function (params){
        if (window.TCRTool == undefined){
            console.log("TCR is undefined");
            return;
        }
        var res = TCRTool.postMessage(JSON.stringify(params));
    },
    }
}) 

window.app = app; 